// extracted by mini-css-extract-plugin
module.exports = {"checkCircleOutlined":"landingTab_checkCircleOutlined__2aGJD","closeCircleOutlined":"landingTab_closeCircleOutlined__3-G8-"};